class MainCart extends HTMLElement {
  loader; themeForm; offcanvas;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    window.addEventListener(Utils.E_CART_ADDED, () => this.reloadCart());
    window.addEventListener(Utils.E_CART_UPDATED, () => this.reloadCart());
    window.addEventListener(Utils.E_CART_REMOVED, () => this.reloadCart());
    this.hideLoader();
  }

  init = () => {
    this.loader = this.querySelector('theme-loader');
    this.themeForm = this.querySelector('theme-form[data-main-form]');

    if(this.themeForm != undefined) {
      this.themeForm.addEventListener(Utils.E_FORM_VALIDATE, (e) => {
        this.toggleButton(e.detail);
      });
  
      this.themeForm.querySelectorAll('input').forEach(input => {
        input.addEventListener('blur', () => {
          this.toggleButton(this.themeForm.isValid());  
        });
        input.addEventListener('change', () => {
          this.toggleButton(this.themeForm.isValid());  
        });
      });
    }

    this.querySelectorAll('[data-track]').forEach(button => {
      button.addEventListener('click', () => {
        const data = {button: button.innerText};
        window.dispatchEvent(new CustomEvent(Utils.E_CART_CLICK, { detail: data}));
        Shopify.analytics.publish(Utils.E_CART_CLICK, data);
      });
    });
  }

  toggleButton = (valid) => {
    this.themeForm.querySelectorAll('[data-submit]').forEach(button => {
      if(valid){
        button.classList.remove(this.dataset.btnInactive);
        button.classList.add(this.dataset.btnActive);
      } else {
        button.classList.remove(this.dataset.btnActive);
        button.classList.add(this.dataset.btnInactive);
      }
    });
  }

  reloadCart = () => {
    console.log('cart.js - Reloading cart');
    this.showLoader();
    if(this.classList.contains('offcanvas')){
      const offcanvas = bootstrap.Offcanvas.getInstance(this) || new bootstrap.Offcanvas(this);
      offcanvas.show();
    }
    const url = new URL(location.href);
    url.searchParams.set('version', (Math.random() + 1).toString(36).substring(7));
    axios.get(url.toString()).then((response) => {
      console.log('cart.js - Cart reloaded');
      const doc = Utils.getDocument(response.data);
      const cart = doc.querySelector('main-cart');
      if(cart) {
        this.innerHTML = cart.innerHTML;
      }
      this.init();
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'cart-reload',
        error: error,
        type: 'axios',
        popup: true
      });
    })
    .finally(() => {
      this.hideLoader();
    });
  }

  showLoader = () => {
    if(this.loader) {
      this.loader.show();
    }
  }

  hideLoader = () => {
    if(this.loader) {
      this.loader.hide();
    }
  }
}
if(!customElements.get('main-cart')) {
  customElements.define('main-cart', MainCart);
}

class CartItem extends HTMLElement {
  static s = {
    remove: '[data-remove]'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.querySelectorAll(CartItem.s.remove).forEach(button => {
      button.addEventListener('click', (e) => this.removeFromCart(e));
    });
  }

  removeFromCart = (e) => {
    e.preventDefault();
    axios.post(window.Shopify.routes.root + 'cart/change.js', {
      id: this.dataset.id,
      quantity: 0
    }).then((response) => {
      window.dispatchEvent(new CustomEvent(Utils.E_CART_REMOVED, { detail: response.data }));
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'cart-item-remove',
        error: error,
        type: 'axios',
        popup: true
      });
    });
  }
}
if(!customElements.get('cart-item')) {
  customElements.define('cart-item', CartItem);
}

class CartEditor extends HTMLElement {
  form; variants; quantitySelector;
  static s = {
    edit: '[data-edit]'
  }

  constructor() {
    super();
    this.form = this.querySelector('form');
    this.variants = this.querySelector('variant-picker');
    this.quantitySelector = this.querySelector('quantity-selector');
    this.init();
  }

  init = () => {
    this.querySelectorAll(CartEditor.s.edit).forEach(button => {
      button.addEventListener('click', (e) => this.update(e));
    });
  }

  update = (e) => {
    e.preventDefault();
    axios.post(window.Shopify.routes.root + 'cart/change.js', {
      id: this.dataset.id,
      quantity: 0
    }).then((response) => {
      this.form = this.querySelector('form');
      Utils.addTocart({
        form: this.form,
        success: (data) => {
          window.dispatchEvent(new CustomEvent(Utils.E_CART_REMOVED, { detail: this.dataset.id }));
        }
      });
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'cart-editor',
        error: error,
        type: 'axios',
        popup: true
      });
    });
  }
}
if(!customElements.get('cart-editor')) {
  customElements.define('cart-editor', CartEditor);
}

class QuantitySelector extends HTMLElement {
  static s = {
    input: 'input[data-input]',
    remove: '[data-remove]',
    add: '[data-add]'
  }
  value; min; max; input; remover; adder; restoreValue;

  connectedCallback() {
    this.input = this.querySelector(QuantitySelector.s.input);
    this.remover = this.querySelector(QuantitySelector.s.remove);
    this.adder = this.querySelector(QuantitySelector.s.add);

    this.value = parseInt(this.input.value);
    this.restoreValue = isNaN(this.value) ? 1 : this.value;
    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.init();
  }

  init = () => {
    this.input.addEventListener('input', (e) => {
      this.setValue(e.target.value);
    });
    this.remover.addEventListener('click', () => this.removeQty(this.remover.dataset.remove));
    this.adder.addEventListener('click', () => this.addQty(this.adder.dataset.add));
  }

  addQty = (num) => {
    const qty = parseInt(num) + this.value;
    this.setValue(qty);    
  }

  removeQty = (num) => {
    const qty = this.value - parseInt(num);
    this.setValue(qty);
  }

  setValue = (qty) => {
    if(!isNaN(qty)) {
      if(this.dataset.min && qty < this.min) {
        qty = this.min;
      }
      if(this.dataset.max && qty > this.max) {
        qty = this.max;
      }
      this.value = qty;
      this.input.value = this.value;
      this.restoreValue = this.value;
      this.dispatchEvent(new CustomEvent(Utils.E_QUANTITY_CHANGE, { detail: this.value }));
    } else {
      this.value = this.restoreValue;
      this.input.value = this.restoreValue;
    }
  }

  setMax = (max) => {
    this.max = max;
  }
}
if(!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}

class CartCounter extends HTMLElement {

  connectedCallback() {
    this.init();
  }

  init = () => {
    window.addEventListener(Utils.E_CART_ADDED, () => this.updateCounter());
    window.addEventListener(Utils.E_CART_UPDATED, () => this.updateCounter());
    window.addEventListener(Utils.E_CART_REMOVED, () => this.updateCounter());
  }

  updateCounter = () => {
    axios.get(location.href).then((response) => {
      const doc = Utils.getDocument(response.data);
      const cart = doc.querySelector('cart-counter');
      if(cart) {
        this.innerHTML = cart.innerHTML;
      }
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'cart-counter',
        error: error,
        type: 'axios'
      });
    });
  }

}
if(!customElements.get('cart-counter')) {
  customElements.define('cart-counter', CartCounter);
}

class CartCode extends HTMLElement {
  input;

  connectedCallback() {
    this.input = this.querySelector('[name="discount"]');
    this.init();
  }

  init = () => {
    this.input.addEventListener('blur', () => this.applyCode());
  }

  applyCode = () => {
    if(this.input.value != null && this.input.value != '') {
      window.dispatchEvent(new CustomEvent(Utils.E_CART_CODE, { detail: {code: this.input.value} }));
    }
  }
}
if(!customElements.get('cart-code')) {
  customElements.define('cart-code', CartCode);
}